<template>
  <div class="container">
    <div class="notification is-warning">
      Note: The payment feature is not ready yet, we will be live soon. This page is just for demo.
    </div>

    <div class="row">
      <div class="col-sm-10">
        <a class="button is-primary" @click="goToHome">
          Back Home
        </a>
        <hr>
        <h1 class="title is-2">Ready to buy?</h1>
        <div class="row">
          <div class="col-sm-6">
            <div>
              <h4>You are buying:</h4>
              <ul>
                <li>Package plan: <em>{{ plan }}</em></li>
                <li>Amount: <em>${{ price }}</em></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-6">
            <h3>One time payment</h3>
            <br>
            <form>
              <div class="form-group">
                <label>Credit Card Info</label>
                <input type="text"
                       class="form-control"
                       placeholder="XXXXXXXXXXXXXXXX"
                       v-model="card.number"
                       required
                       disabled>
              </div>
              <div class="form-group">
                <input type="text"
                       class="form-control"
                       placeholder="CVC"
                       v-model="card.cvc"
                       required
                       disabled>
              </div>
              <div class="form-group">
                <label>Card Expiration Date</label>
                <input type="text"
                       class="form-control"
                       placeholder="MM/YY"
                       v-model="card.exp"
                       required
                       disabled>
              </div>
              <button class="btn btn-primary btn-block"
                      @click.prevent="validate"
                      :disabled="stripeCheck"
                      disabled>
                  Submit
              </button>
            </form>
            <div v-show="errors">
              <br>
              <ol class="text-danger">
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import helper from '@/helper'

export default {
  name: 'order',
  props: ['package'],
  data() {
    return {
      plan: this.$route.params.plan,
      price: parseInt(this.$route.params.price),
      book: {
        title: '',
        author: '',
        read: [],
        price: '',
      },
      card: {
        number: '',
        cvc: '',
        exp: '',
      },
      errors: [],
      stripePublishableKey: 'pk_test_AI3LZGO2CaIxHu5zKmh5Ujbc00kpGKMGNN',
      stripeCheck: false,
    };
  },
  methods: {
    getBook() {
      const path = `http://localhost:5000/books/${this.$route.params.id}`;
      axios.get(path)
        .then((res) => {
          this.book = res.data.book;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    validate() {
      this.errors = [];
      let valid = true;
      if (!this.card.number) {
        valid = false;
        this.errors.push('Card Number is required');
      }
      if (!this.card.cvc) {
        valid = false;
        this.errors.push('CVC is required');
      }
      if (!this.card.exp) {
        valid = false;
        this.errors.push('Expiration date is required');
      }
      if (valid) {
        this.createToken();
      }
    },
    createToken() {
      this.stripeCheck = true;
      window.Stripe.setPublishableKey(this.stripePublishableKey);
      window.Stripe.createToken(this.card, (status, response) => {
        if (response.error) {
          this.stripeCheck = false;
          this.errors.push(response.error.message);
          // eslint-disable-next-line
          console.error(response);
        } else {
          const payload = {
            book: this.book,
            token: response.id,
          };
          const path = 'https://ml-midterm-service.onrender.com/charge';
          axios.post(path, payload)
            .then((res) => {
              // updates
              this.$router.push({ path: `/complete/${res.data.charge.id}` });
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error);
            });
        }
      });
    },
    goToHome() {
      helper.updatePurchaseView(false)
      this.$router.push('/')
    }
  },
  created() {
    this.getBook();
  },
};
</script>
